import { Component, OnDestroy, OnInit, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { ValidationErrorsComponent } from '../../../../../common/validation-errors/validation-errors.component';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import { PropertyDataForm } from './forms/property-data.form';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { updateParcels } from '../../../../../store/actions/application.actions';
import { ParcelItemForm } from '../components/parcels/parcel-item.form';
import { ParcelsCrudComponent } from '../components/parcels/parcels-crud/parcels-crud.component';

export interface WPropertyDataComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
  addHouseNumberControl?: boolean;
  addStreetControl?: boolean;
}

@Component({
  selector: 'app-w-property-data-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    ValidationErrorsComponent,
    StagesComponent,
    ParcelsCrudComponent
  ],
  providers: [PropertyDataForm, ParcelItemForm],
  templateUrl: './w-property-data-section.component.html'
})
export class WPropertyDataSectionComponent implements OnInit, OnDestroy {

  public stages: string[] = this.route.snapshot.data['stages'];

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  constructor(
    public form: PropertyDataForm,
    private store$: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate([this.cancelUrl], { relativeTo: this.route });
  }

  public ngOnInit(): void {
    if (this.route.snapshot.data['addHouseNumberControl']) {
      this.form.createHouseNumberControls();
    }
    if (this.route.snapshot.data['addStreetControl']) {
      this.form.createStreetControl();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
